import { render } from "./MetadataEdit.vue?vue&type=template&id=17fde0f6&scoped=true"
import script from "./MetadataEdit.vue?vue&type=script&lang=js"
export * from "./MetadataEdit.vue?vue&type=script&lang=js"

import "./MetadataEdit.vue?vue&type=style&index=0&id=17fde0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fde0f6"]])

export default __exports__